import { ChevronDown } from "lucide-react";
import type { Ref, SelectHTMLAttributes } from "react";
import { cx } from "../cx.ts";
import { CONTROL_CLASSES } from "./Input.tsx";

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options?: readonly SelectOption[];
  /** A first, empty option (for "none chosen"). */
  placeholder?: string;
  invalid?: boolean;
  ref?: Ref<HTMLSelectElement>;
}

/** A native select (the phone's own picker is the most usable one) with the shared look. */
export function Select({
  options,
  placeholder,
  invalid,
  className,
  children,
  ref,
  ...rest
}: SelectProps) {
  return (
    <div className={cx("relative", className)}>
      <select
        ref={ref}
        className={cx(
          CONTROL_CLASSES,
          "appearance-none pr-10",
          invalid && "border-danger ring-1 ring-danger",
        )}
        {...rest}
      >
        {placeholder !== undefined ? <option value="">{placeholder}</option> : null}
        {options?.map((o) => (
          <option key={o.value} value={o.value} disabled={o.disabled}>
            {o.label}
          </option>
        ))}
        {children}
      </select>
      <ChevronDown
        aria-hidden
        className="pointer-events-none absolute top-1/2 right-3 size-4 -translate-y-1/2 text-ink-muted"
      />
    </div>
  );
}
